<div class="organization-flow-page">
  <div class="organization-swap-shell" [class.show-members-view]="showMembersView" [class.show-audit-view]="showAuditView" [class.show-audit-detail-view]="showAuditDetailView">
    <div class="swap-track">
      <section class="swap-panel organizations-panel">
        <div class="surface-card p-4 shadow-2 border-round h-full">
          <div class="panel-header">
            <div>
              <h2 class="m-0 text-900 font-bold text-2xl">Organizations</h2>
              <div class="text-500 text-sm">Browse all organizations and click one to view its members.</div>
            </div>

            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-refresh"
              class="p-button-text p-button-secondary"
              pTooltip="Reload organizations"
              tooltipPosition="left"
              (click)="loadOrganizations(true)">
            </button>
          </div>

        <div class="panel-toolbar">
          <span class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              placeholder="Search organizations..."
              class="w-full"
              [(ngModel)]="organizationSearchTerm"
              (ngModelChange)="onOrganizationSearchTermChange($event)" />
          </span>
        </div>

        <div class="table-toolbar flex align-items-center justify-content-between mb-4">
          <div class="text-sm text-500">Showing {{ organizations.length }} of {{ organizationTotalRecords }} organizations</div>
        </div>

        <div class="organization-card-list" *ngIf="filteredOrganizations.length; else noOrganizationsState">
          <article
            *ngFor="let organization of filteredOrganizations"
            class="organization-card"
            [class.selected]="selectedOrganization?.id === organization.id"
            role="button"
            tabindex="0"
            (click)="openOrganizationMembers(organization)"
            (keydown.enter)="openOrganizationMembers(organization)">
            <div class="organization-card-main">
              <div class="organization-card-title-row">
                <div class="organization-card-title-left">
                  <div class="organization-name-status-row">
                    <div class="organization-name">{{ organization.name || 'Untitled organization' }}</div>
                    <p-tag
                      [value]="getOrganizationStatus(organization)"
                      [severity]="getOrganizationStatusSeverity(organization)">
                    </p-tag>
                  </div>
                  <div class="organization-card-meta-row">
                    <div class="organization-subtext">#{{ organization.id }} · {{ organization.slug || 'no-slug' }}</div>
                    <div class="organization-subtext" *ngIf="organization.email">{{ organization.email }}</div>
                  </div>
                </div>
              </div>
              <div class="organization-card-footer">
                <span class="card-chip" *ngIf="organization.totalMembers !== undefined">
                  <strong>Members:</strong> {{ organization.totalMembers }}
                </span>
                <span class="card-chip" *ngIf="organization.createdDate">
                  <strong>Created:</strong> {{ organization.createdDate | date:'mediumDate' }}
                </span>
              </div>
            </div>
          </article>
        </div>

        <ng-template #noOrganizationsState>
          <div class="empty-state text-center text-500">
            <i class="pi pi-building text-4xl mb-3"></i>
            <div>{{ organizationSearchTerm ? 'No organizations match your search.' : 'No organizations found.' }}</div>
          </div>
        </ng-template>

        <p-paginator
          [rows]="organizationPageSize"
          [totalRecords]="organizationTotalRecords"
          [rowsPerPageOptions]="[25,50,100]"
          [first]="(organizationPage - 1) * organizationPageSize"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          (onPageChange)="onOrganizationPage($event)">
        </p-paginator>
      </div>
      </section>

      <section class="swap-panel members-panel">
        <div class="surface-card p-4 shadow-2 border-round h-full">
          <div class="mb-4 flex flex-wrap align-items-center justify-content-between gap-3 members-header-card">
            <div class="flex align-items-center gap-3">
              <button
                pButton
                pRipple
                type="button"
                label="Back"
                icon="pi pi-arrow-left"
                class="p-button-text p-button-secondary back-button"
                (click)="backToOrganizations()">
              </button>

              <div>
                <h2 class="m-0 text-900 font-bold text-2xl">Organization Members</h2>
                <div class="text-500 text-sm" *ngIf="selectedOrganization; else selectOrganizationMessage">
                  Viewing members for <strong>{{ selectedOrganization.name }}</strong> (#{{ selectedOrganization.id }}).
                </div>
                <ng-template #selectOrganizationMessage>
                  <div class="text-500 text-sm">Select an organization to inspect its members.</div>
                </ng-template>
              </div>
            </div>

            <div class="members-header-actions" *ngIf="selectedOrganization">
              <button
                pButton
                pRipple
                type="button"
                label="Audit Logs"
                icon="pi pi-history"
                class="p-button-text"
                (click)="openOrganizationAuditLogs(selectedOrganization)">
              </button>
              
              <button
                pButton
                pRipple
                type="button"
                label="Organization Details"
                icon="pi pi-info-circle"
                class="p-button-text"
                (click)="openOrganizationDetails(selectedOrganization)">
              </button>

              <gig-action-button
                [buttons]="selectedOrganizationActionButtons"
                customClass="organization-detail-action-buttons"
                (buttonClick)="handleSelectedOrganizationAction($event)">
              </gig-action-button>

              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-refresh"
                class="p-button-text p-button-secondary"
                [disabled]="!selectedOrganization"
                pTooltip="Reload member list"
                tooltipPosition="left"
                (click)="reloadSelectedOrganizationMembers()">
              </button>
            </div>
          </div>

          <ng-container *ngIf="selectedOrganization; else emptySelectionState">
            <div class="members-summary-grid surface-ground p-4 border-round mb-4">
              <div class="summary-main">
                <div class="text-900 font-bold text-xl mb-1">{{ selectedOrganization.name || 'Organization' }}</div>
                <div class="text-500 text-sm">#{{ selectedOrganization.id }} · {{ selectedOrganization.slug || 'No slug' }}</div>
                <div class="text-500 text-sm mt-3">{{ selectedOrganization.email || 'No email available' }}</div>
              </div>

              <div class="summary-metrics">
                <span class="meta-chip">
                  <strong>Members</strong>
                  {{ memberTotalRecords }}
                </span>
                <span class="meta-chip" *ngIf="selectedOrganization.createdDate">
                  <strong>Created</strong>
                  {{ selectedOrganization.createdDate | date:'mediumDate' }}
                </span>
                <span class="meta-chip">
                  <strong>Status</strong>
                  {{ getOrganizationStatus(selectedOrganization) }}
                </span>
              </div>
            </div>

            <section class="usage-section surface-card border-1 border-200 border-round p-4 mb-4" aria-labelledby="usage-heading">
              <div class="flex flex-wrap justify-content-between align-items-start gap-3 mb-3">
                <div>
                  <h3 id="usage-heading" class="m-0 text-900">Current-period usage</h3>
                  <div class="text-500 text-sm mt-1" *ngIf="usageSummary">
                    {{ usageSummary.period.startUtc | date:'mediumDate' }}–{{ usageSummary.period.endUtc | date:'mediumDate' }}
                    · Updated {{ usageSummary.updatedAtUtc ? (usageSummary.updatedAtUtc | date:'medium') : 'not yet' }}
                  </div>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-tag
                    *ngIf="usageSummary"
                    [value]="usageSummary.mode"
                    [severity]="getUsageModeSeverity(usageSummary.mode)">
                  </p-tag>
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-refresh"
                    class="p-button-text p-button-secondary"
                    [disabled]="usageLoading"
                    aria-label="Reload authoritative usage"
                    pTooltip="Reload authoritative usage"
                    (click)="loadOrganizationUsage(selectedOrganization.id)">
                  </button>
                </div>
              </div>

              <div *ngIf="usageLoading" class="text-500 py-3">Loading authoritative usage…</div>
              <div *ngIf="!usageLoading && usageError" class="usage-error p-3 border-round">
                <i class="pi pi-exclamation-triangle mr-2"></i>{{ usageError }}
              </div>

              <ng-container *ngIf="!usageLoading && usageSummary as usage">
                <div class="usage-metrics-grid mb-4">
                  <div class="usage-metric"><span>Vendor cost</span><strong>{{ usage.vendorCost | currency:'USD' }}</strong></div>
                  <div class="usage-metric"><span>Settled customer units</span><strong>{{ usage.settledCustomerUnits | number }}</strong></div>
                  <div class="usage-metric"><span>Reserved units</span><strong>{{ usage.reservedCustomerUnits | number }}</strong></div>
                  <div class="usage-metric"><span>Delivered units</span><strong>{{ usage.deliveredCustomerUnits | number }}</strong></div>
                  <div class="usage-metric"><span>Vendor units</span><strong>{{ usage.vendorUnits | number }}</strong></div>
                  <div class="usage-metric"><span>Operations</span><strong>{{ usage.operationCount | number }}</strong></div>
                </div>

                <p-table [value]="usageOperations" styleClass="p-datatable-sm admin-table usage-table">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Operation</th>
                      <th>Provider</th>
                      <th>State</th>
                      <th class="text-right">Customer units</th>
                      <th class="text-right">Vendor units</th>
                      <th class="text-right">Vendor cost</th>
                      <th>Updated</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-operation>
                    <tr>
                      <td>
                        <div class="font-medium text-900">{{ operation.operationKey }}</div>
                        <div class="text-500 text-xs usage-operation-id">{{ operation.operationId }}</div>
                        <div *ngIf="operation.traceId" class="text-500 text-xs usage-operation-id">Trace: {{ operation.traceId }}</div>
                      </td>
                      <td>{{ operation.providerName || '—' }}</td>
                      <td><p-tag [value]="operation.state || 'unknown'"></p-tag></td>
                      <td class="text-right">{{ operation.settledCustomerUnits | number }}</td>
                      <td class="text-right">{{ operation.vendorUnits | number }}</td>
                      <td class="text-right">{{ operation.vendorCost | currency:'USD' }}</td>
                      <td>{{ operation.updatedAtUtc | date:'short' }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr><td colspan="7" class="text-center text-500 py-4">No ledger operations in this period.</td></tr>
                  </ng-template>
                </p-table>
                <p-paginator
                  *ngIf="usageTotalRecords > usagePageSize"
                  [rows]="usagePageSize"
                  [totalRecords]="usageTotalRecords"
                  [first]="(usagePage - 1) * usagePageSize"
                  [rowsPerPageOptions]="[10,25,50]"
                  (onPageChange)="onUsagePage($event)">
                </p-paginator>
              </ng-container>
            </section>

            <div class="table-section">
              <div class="table-toolbar flex align-items-center justify-content-between mb-4">
                <div class="text-sm text-500">Showing {{ memberTotalRecords }} members</div>
                <span class="p-input-icon-left search-box">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    class="search-input"
                    placeholder="Search members by name, email, role, status"
                    [(ngModel)]="memberSearchTerm"
                    (ngModelChange)="onMemberSearchTermChange($event)" />
                </span>
              </div>

              <p-table
                [value]="organizationMembers"
                [rowHover]="true"
                dataKey="userId"
                styleClass="p-datatable-sm admin-table members-table"
                [paginator]="true"
                [rows]="memberPageSize"
                [totalRecords]="memberTotalRecords"
                [rowsPerPageOptions]="[10,20,50]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                (onPage)="onMemberPage($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="px-4 py-3">User</th>
                    <th class="px-4 py-3">Role</th>
                    <th class="px-4 py-3">Status</th>
                    <th class="px-4 py-3">Last Active</th>
                    <th class="px-4 py-3 text-right">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-member>
                  <tr>
                    <td class="px-4 py-3">
                      <div class="font-semibold text-900">{{ member.name || 'Unknown member' }}</div>
                      <div class="text-500 text-sm">{{ member.email || 'No email available' }}</div>
                    </td>
                    <td class="px-4 py-3">{{ member.role || '—' }}</td>
                    <td class="px-4 py-3">
                      <p-tag [value]="member.status || 'Unknown'" [severity]="getMemberStatusSeverity(member)"></p-tag>
                    </td>
                    <td class="px-4 py-3">{{ member.lastActiveUtc ? (member.lastActiveUtc | date:'medium') : '—' }}</td>
                    <td class="px-4 py-3 text-right">
                      <ng-container *ngIf="!isBillingOwner(member); else billingOwnerActions">
                        <gig-action-button
                          [buttons]="getMemberDeleteButtons()"
                          customClass="member-action-button"
                          (click)="$event.stopPropagation()"
                          (buttonClick)="handleMemberAction($event, member)">
                        </gig-action-button>
                      </ng-container>
                      <ng-template #billingOwnerActions>
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-exclamation-triangle"
                          class="p-button-text p-button-danger billing-owner-warning-button"
                          pTooltip="Cannot delete Billing Owner"
                          tooltipPosition="left"
                          (click)="$event.stopPropagation(); openBillingOwnerWarningDialog(member)">
                        </button>
                      </ng-template>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5" class="text-center text-500 py-5">
                      No members found for this organization.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-container>

          <ng-template #emptySelectionState>
            <div class="empty-state text-center text-500">
              <i class="pi pi-building text-4xl mb-3"></i>
              <div>Select an organization from the list to load its members.</div>
            </div>
          </ng-template>
      </div>
      </section>

      <section class="swap-panel audit-panel">
        <div class="surface-card p-4 shadow-2 border-round h-full">
          <div class="mb-4 flex flex-wrap align-items-center justify-content-between gap-3 members-header-card">
            <div class="flex align-items-center gap-3">
              <button
                pButton
                pRipple
                type="button"
                label="Back"
                icon="pi pi-arrow-left"
                class="p-button-text p-button-secondary back-button"
                (click)="backToMembersFromAudit()">
              </button>

              <div>
                <h2 class="m-0 text-900 font-bold text-2xl">Organization Audit Logs</h2>
                <div class="text-500 text-sm" *ngIf="selectedOrganization; else selectOrganizationForAuditMessage">
                  Viewing logs for <strong>{{ selectedOrganization.name }}</strong> (#{{ selectedOrganization.id }}).
                </div>
                <ng-template #selectOrganizationForAuditMessage>
                  <div class="text-500 text-sm">Select an organization to inspect its audit logs.</div>
                </ng-template>
              </div>
            </div>

            <div class="members-header-actions" *ngIf="selectedOrganization as org">
              <button
                pButton
                pRipple
                type="button"
                icon="pi pi-refresh"
                class="p-button-text p-button-secondary"
                [disabled]="organizationAuditLoading"
                pTooltip="Reload audit logs"
                tooltipPosition="left"
                (click)="loadOrganizationAuditLogs(org.id, true)">
              </button>
            </div>
          </div>

          <ng-container *ngIf="selectedOrganization; else emptyAuditSelectionState">
            <div class="table-section">
              <div class="table-toolbar flex align-items-center justify-content-between mb-4">
                <div class="text-sm text-500">
                  Showing {{ organizationAuditLogs.length }} of {{ organizationAuditTotalRecords }} logs
                </div>
              </div>

              <p-table
                [value]="organizationAuditLogs"
                [rowHover]="true"
                styleClass="p-datatable-sm admin-table organization-audit-table"
                [paginator]="true"
                [rows]="organizationAuditPageSize"
                [totalRecords]="organizationAuditTotalRecords"
                [rowsPerPageOptions]="[10,20,50]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                (onPage)="onOrganizationAuditPage($event)">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="px-4 py-3">Date</th>
                    <th class="px-4 py-3">Actor</th>
                    <th class="px-4 py-3">Action</th>
                    <th class="px-4 py-3">Target</th>
                    <th class="px-4 py-3">Summary</th>
                    <th class="px-4 py-3 text-right">Details</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-audit>
                  <tr>
                    <td class="px-4 py-3">{{ getAuditDateDisplay(audit.createdDate) }}</td>
                    <td class="px-4 py-3">{{ audit.actorName || audit.actorUserId || 'Unknown actor' }}</td>
                    <td class="px-4 py-3">{{ audit.action || '—' }}</td>
                    <td class="px-4 py-3">{{ getAuditTargetDisplay(audit) }}</td>
                    <td class="px-4 py-3">
                      <span class="audit-summary">{{ audit.summary || '—' }}</span>
                    </td>
                    <td class="px-4 py-3 text-right">
                      <button
                        pButton
                        pRipple
                        type="button"
                        class="p-button-text p-button-sm"
                        label="View"
                        [disabled]="organizationAuditDetailLoading"
                        (click)="viewOrganizationAuditDetails(audit)">
                      </button>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6" class="text-center text-500 py-5">
                      <ng-container *ngIf="organizationAuditLoading; else noAuditLogsState">
                        Loading audit logs...
                      </ng-container>
                      <ng-template #noAuditLogsState>
                        No audit logs found for this organization.
                      </ng-template>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-container>

          <ng-template #emptyAuditSelectionState>
            <div class="empty-state text-center text-500">
              <i class="pi pi-history text-4xl mb-3"></i>
              <div>Select an organization from members view to load audit logs.</div>
            </div>
          </ng-template>
        </div>
      </section>

      <section class="swap-panel audit-detail-panel">
        <div class="surface-card p-4 shadow-2 border-round h-full">
          <div class="mb-4 flex flex-wrap align-items-center justify-content-between gap-3 members-header-card">
            <div class="flex align-items-center gap-3">
              <button
                pButton
                pRipple
                type="button"
                label="Back to logs"
                icon="pi pi-arrow-left"
                class="p-button-text p-button-secondary back-button"
                (click)="backToAuditLogsFromDetail()">
              </button>

              <div>
                <h2 class="m-0 text-900 font-bold text-2xl">Audit Log Detail</h2>
                <div class="text-500 text-sm" *ngIf="selectedOrganization">
                  {{ selectedOrganization.name }} (#{{ selectedOrganization.id }})
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="organizationAuditDetailLoading; else auditDetailContent">
            <div class="text-500 py-4">Loading audit detail...</div>
          </ng-container>

          <ng-template #auditDetailContent>
            <div class="audit-detail-layout" *ngIf="selectedOrganizationAuditLog as auditDetail; else emptyAuditDetailState">
              <section class="audit-detail-card">
                <div class="audit-detail-card-title">Overview</div>

                <table class="audit-detail-table" role="table" aria-label="Audit overview">
                  <tbody>
                    <tr>
                      <th scope="row">Audit ID</th>
                      <td class="audit-monospace">{{ auditDetail.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Date</th>
                      <td>{{ getAuditDateDisplay(auditDetail.createdDate) }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Actor</th>
                      <td>{{ auditDetail.actorName || auditDetail.actorUserId || 'Unknown actor' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Action</th>
                      <td>
                        <p-tag
                          [value]="auditDetail.action || 'Unknown action'"
                          [severity]="getAuditActionSeverity(auditDetail.action)">
                        </p-tag>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Target</th>
                      <td>
                        <div class="audit-target-cell">
                          <p-tag
                            [value]="auditDetail.targetType || 'Unknown target'"
                            [severity]="getAuditTargetSeverity(auditDetail.targetType)">
                          </p-tag>
                          <span class="audit-monospace">{{ auditDetail.targetId || '—' }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">IP Address</th>
                      <td>{{ auditDetail.ipAddress || '—' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">User Agent</th>
                      <td>{{ auditDetail.userAgent || '—' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Summary</th>
                      <td>{{ auditDetail.summary || '—' }}</td>
                    </tr>
                  </tbody>
                </table>
              </section>

              <section class="audit-detail-card">
                <div class="audit-detail-card-title">Metadata</div>

                <div class="audit-metadata-table-wrap" *ngIf="getAuditMetadataRows(auditDetail).length; else noMetadataState">
                  <table
                    class="audit-detail-table"
                    role="table"
                    aria-label="Audit metadata">
                    <thead>
                      <tr>
                        <th scope="col">Field</th>
                        <th scope="col">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of getAuditMetadataRows(auditDetail)">
                        <td class="audit-metadata-key">{{ item.key }}</td>
                        <td class="audit-monospace">{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <ng-template #noMetadataState>
                  <div class="text-500">No metadata available.</div>
                </ng-template>
              </section>
            </div>
          </ng-template>

          <ng-template #emptyAuditDetailState>
            <div class="empty-state text-center text-500">
              <i class="pi pi-info-circle text-4xl mb-3"></i>
              <div>Select an audit log record to view details.</div>
            </div>
          </ng-template>
        </div>
      </section>
    </div>
  </div>
</div>

<p-sidebar
  [(visible)]="showOrganizationDetailsDrawer"
  position="right"
  [style]="{ width: '30rem', maxWidth: '100vw' }"
  [modal]="false"
  [blockScroll]="true"
  styleClass="organization-details-drawer"
  (onHide)="closeOrganizationDetails()">
  <ng-template pTemplate="header">
    <div class="drawer-header" *ngIf="selectedOrganization as org">
      <div>
        <div class="drawer-title">Organization Details</div>
        <div class="drawer-subtitle">{{ org.name || 'Untitled organization' }} (#{{ org.id }})</div>
      </div>
      <p-tag
        [value]="getOrganizationStatus(org)"
        [severity]="getOrganizationStatusSeverity(org)">
      </p-tag>
    </div>
  </ng-template>

  <ng-container *ngIf="selectedOrganization as org">
    <div class="drawer-body">
      <div class="drawer-logo" *ngIf="org.logoUrl">
        <img [src]="org.logoUrl" alt="Organization logo" />
      </div>

      <div class="detail-grid">
        <div class="detail-row" *ngFor="let row of getOrganizationDetailsRows(org)">
          <div class="detail-label">{{ row.label }}</div>
          <div class="detail-value">{{ row.value }}</div>
        </div>

        <div class="detail-row detail-row-address">
          <div class="detail-label">Address</div>
          <div class="detail-value">{{ getOrganizationAddressDisplay(org) }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</p-sidebar>

<gig-confirmation-dialog
  [(visible)]="showOrganizationDeleteConfirmDialog"
  [type]="organizationDeleteDialogType"
  [title]="organizationDeleteDialogTitle"
  [message]="organizationDeleteMessage"
  [hasProjectedContent]="organizationDeleteMode === 'hard'">
  <div body *ngIf="organizationDeleteMode === 'hard'" class="hard-delete-confirmation-body">
    <p class="text-sm text-500 mb-2">
      Type <strong>CONFIRM</strong> in the box below to enable the Continue button.
    </p>
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Type CONFIRM to enable"
      [(ngModel)]="hardDeleteConfirmationInput"
      (ngModelChange)="refreshOrganizationDeleteActionButtons()" />
  </div>
  <gig-action-button
    [buttons]="organizationDeleteActionButtons"
    (buttonClick)="handleOrganizationDelete($event)">
  </gig-action-button>
</gig-confirmation-dialog>

<gig-confirmation-dialog
  [(visible)]="showMemberDeleteConfirmDialog"
  [type]="'delete'"
  [title]="'Delete Member'"
  [message]="memberDeleteMessage"
  [hasProjectedContent]="true">
  <div body class="hard-delete-confirmation-body">
    <p class="text-sm text-500 mb-2">
      Type <strong>CONFIRM</strong> in the box below to enable the Delete button.
    </p>
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Type CONFIRM to enable"
      [(ngModel)]="memberDeleteConfirmationInput"
      (ngModelChange)="refreshMemberDeleteActionButtons()" />
  </div>
  <gig-action-button
    [buttons]="memberDeleteActionButtons"
    (buttonClick)="handleMemberDelete($event)">
  </gig-action-button>
</gig-confirmation-dialog>

<gig-confirmation-dialog
  [(visible)]="showBillingOwnerWarningDialog"
  [type]="'warning'"
  [title]="'Cannot delete Billing Owner'"
  [message]="billingOwnerWarningMessage">
  <gig-action-button
    [buttons]="billingOwnerWarningButtons"
    (buttonClick)="handleBillingOwnerWarningDialog($event)">
  </gig-action-button>
</gig-confirmation-dialog>
